import React, { useState, useEffect } from 'react';
import { Card, Button, Form, Col, Table } from 'react-bootstrap';
import '~/assets/css/icons.css';
import '~/assets/css/styles.css';
import { withNamespaces } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import RoleTable from '~/components/role/RoleTable';
import { defaultApps } from './defaultApps';
import { getRoles, clearRoles } from "~/pages/Admin/Role/actions"

const PersistSource = ({ selectedSource, editSource, ...props }) => {

  const { t } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const [sourceName, setSourceName] = useState(selectedSource ? selectedSource.name : "");
  const [url, setUrl] = useState(selectedSource ? selectedSource.url : "");
  const [groupId, setGroupId] = useState(selectedSource ? selectedSource.url.split(",")[0] : "");
  const [reportId, setReportId] = useState(selectedSource ? selectedSource.url.split(",")[1] : "");
  const [isAuthentication, setisAuthentication] = useState(selectedSource ? selectedSource.authentication : "");
  const [availableRoles, setAvailableRoles] = useState([])
  const [selectedRoles, setSelectedRoles] = useState([])

  const { roles } = useSelector(state => state.roleReducer);
  useEffect(() => {
    dispatch(getRoles());
    return () => {
      dispatch(clearRoles());
    }
  }, [dispatch]);

  useEffect(() => {
    if (selectedSource && selectedSource.roles) {
      const selectedRoleIds = selectedSource.roles
      const selectedRoles_ = roles.filter(role => selectedRoleIds.some(id => id === role.id))
      const availableRoles_ = roles.filter(role => !selectedRoleIds.some(id => id === role.id))
      setSelectedRoles(selectedRoles_)
      setAvailableRoles(availableRoles_)
    } else {
      setAvailableRoles(roles)
    }
  }, [selectedSource, roles]);

  const [apps, setApps] = useState(defaultApps);
  const [isAllAppChosen, setIsAllAppChosen] = useState(false);

  useEffect(() => {
    if (selectedSource) {
      defaultApps.forEach(item => item.toggle = false);//clear state
      let savedApps = defaultApps.map((item) => {
        if (selectedSource.apps.some((app) => app.description === item.description)) {
          item.toggle = true;
          return item;
        }
        else return item;
      })
      setApps(savedApps);
    }
  }, [selectedSource])

  useEffect(() => {
    if (apps) {
      if (apps.some(app => app.toggle === false))
        setIsAllAppChosen(false);
      else
        setIsAllAppChosen(true);
    }
  }, [apps])


  const toggleApp = (appname) => {
    let updatedApps = apps.map((item) => {
      if (item.description === appname) {
        item.toggle = !item.toggle;
        return item;
      }
      else return item;
    })
    setApps(updatedApps);
  };

  const toggleAll = () => {
    let toggledApps
    if (isAllAppChosen) {
      toggledApps = apps && apps.map(item => {
        item.toggle = false
        return item
      })
    } else {
      toggledApps = apps && apps.map(item => {
        item.toggle = true
        return item
      })
    }
    setApps(toggledApps)
  };

  const toggleAuthentication = () => {
    setisAuthentication(!isAuthentication);
    setUrl("");
  };

  const getTableRows = () => {
    return apps && apps.map((item, index) => {
      return (
        <tr key={index + 1}>
          <th>{item.description}</th>
          <th>
            <Form.Check
              type="switch"
              id={index + 1}
              label=""
              checked={item.toggle}
              onChange={() => toggleApp(item.description)}
            />
          </th>
        </tr>
      )
    })
  };

  const addRole = (role) => {
    setAvailableRoles(roles => roles.filter(r => r.id !== role.id))
    if (!selectedRoles.some(r => r.id === role.id)) {
      let newRoles = [...selectedRoles, role]
      newRoles.sort((a, b) => a.id - b.id);
      setSelectedRoles(newRoles)
    }
  };

  const removeRole = (role) => {
    setSelectedRoles(roles => roles.filter(r => r.id !== role.id))
    if (!availableRoles.some(r => r.id === role.id)) {
      let newRoles = [...availableRoles, role]
      newRoles.sort((a, b) => a.id - b.id);
      setAvailableRoles(newRoles)
    }
  };

  const [validated, setValidated] = useState(false);
  const handleSubmit = event => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
    }
    else {
      let newConfiguration = {
        url: isAuthentication ? `${groupId},${reportId}` : url,
        name: sourceName,
        authentication: isAuthentication,
        apps: apps.filter(app => app.toggle === true)
      }
      if (selectedRoles.length > 0) {
        newConfiguration.roles = selectedRoles.map(role => role.id)
      }
      editSource(newConfiguration);
    }
  };

  const backToList = () => {
    history.push("/uniksystem/admin/widgetsettings/ServicoGenericoWidget");
  };

  return (
    <>
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        method="post"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Card.Body>
          <Form.Row>
            <Col>
              <Form.Group controlId="sourcename">
                <Form.Label>
                  {t('ServicoGenericoWidget.sourceName')}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t('ServicoGenericoWidget.typeSource')}
                  value={sourceName}
                  onChange={e => setSourceName(e.target.value)}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {t('ServicoGenericoWidget.validSource')}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Form.Row>
          <Form.Group controlId="formBasicCheckbox">
            <Form.Check
              type="checkbox"
              label="Autenticação"
              checked={isAuthentication}
              onChange={() => toggleAuthentication()} />
          </Form.Group>

          {isAuthentication ? <Form.Row>
            <Col >
              <Form.Group controlId="url">
                <Form.Label>
                  Group Id
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={"Group Id"}
                  required
                  value={groupId}
                  onChange={e => setGroupId(e.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                  {t('ServicoGenericoWidget.validURL')}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col >
              <Form.Group controlId="url">
                <Form.Label>
                  Report Id
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={"Report Id"}
                  required
                  value={reportId}
                  onChange={e => setReportId(e.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                  {t('ServicoGenericoWidget.validURL')}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Form.Row> :
            <Form.Row>
              <Col >
                <Form.Group controlId="url">
                  <Form.Label>
                    {t('general.URL')}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={t('ServicoGenericoWidget.typeURL')}
                    required
                    value={url}
                    onChange={e => setUrl(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t('ServicoGenericoWidget.validURL')}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Form.Row>
          }

          <Form.Group controlId="formBasicCheckbox1">
            <Form.Check
              type="checkbox"
              label={t('ServicoGenericoWidget.chooseAll')}
              checked={isAllAppChosen}
              onChange={() => toggleAll()} />
          </Form.Group>

          <Table id="user-table" striped bordered hover>
            <thead>
              <tr>
                <th>
                  {t('ServicoGenericoWidget.application')}
                </th>
                <th>
                  {t('ServicoGenericoWidget.access')}
                </th>
              </tr>
            </thead>
            <tbody>
              {getTableRows()}
            </tbody>
          </Table>

          <Form.Row>
            <Col sm="12" md="12" lg="6">
              <Form.Group controlId="label">
                <Form.Label>
                  {t('admin.role.list.availableRoles')}
                </Form.Label>
                <RoleTable
                  roles={availableRoles}
                  action={addRole}
                  actionIcon="icon-add"
                />
              </Form.Group>
            </Col>

            <Col sm="12" md="12" lg="6">
              <Form.Group controlId="label">
                <Form.Label>
                  {t('admin.role.list.selectedRoles')}
                </Form.Label>
                <RoleTable
                  roles={selectedRoles}
                  action={removeRole}
                  actionIcon="icon-trash"
                />
              </Form.Group>
            </Col>
          </Form.Row>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            onClick={() => backToList()}
          >
            {t('general.back')}
          </Button>
          <Button
            type="submit"
            className="card-button"
            style={{ marginLeft: "10px", marginRight: "55px" }}
          >
            {t('general.save')}
          </Button>
        </Card.Footer>
      </Form>
    </>
  )
}

export default withNamespaces()(PersistSource);